import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22pricing.tsx%22,%22import%22:%22Permanent_Marker%22,%22arguments%22:[{%22weight%22:%22400%22,%22subsets%22:[%22latin%22]}],%22variableName%22:%22permanentMarker%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Permanent Marker', 'Permanent Marker Fallback'",
        fontWeight: 400,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
